import { api } from 'data/api/api'

import {
  CreateDigitalProductPassportDraftItemResp,
  CreateProIntegrationsApplicationArgs,
  ProIntegrationsTermsAndConditionsResp,
} from '../types/pro-integrations'

export const createDigitalProductPassportDraftItem = (dppRef: string) =>
  api.post<CreateDigitalProductPassportDraftItemResp>(`/dpp/items/${dppRef}/draft`)

export const createProIntegrationsApplication = (data: CreateProIntegrationsApplicationArgs) =>
  api.post('/vpi/application', data)

export const getProIntegrationsTermsAndConditionsContent = () =>
  api.get<ProIntegrationsTermsAndConditionsResp>('/pro_integrations_terms_and_conditions')
